import { Container } from "@material-ui/core";
import { ConfirmButtonTransitionState } from "@saleor/components/ConfirmButton";
import Form from "@saleor/components/Form";
import Grid from "@saleor/components/Grid";
import PageBackNavigation from "@saleor/components/PageBackNavigation";
import PageBreadcrumbNavigation from "@saleor/components/PageBreadcrumbNavigation/PageBreadcrumbNavigation";
import PageHeader from "@saleor/components/PageHeader";
import SaveButtonBar from "@saleor/components/SaveButtonBar";
import { BrandErrorFragment } from "@saleor/fragments/types/BrandErrorFragment";
import { SubmitPromise } from "@saleor/hooks/useForm";
import useStateFromProps from "@saleor/hooks/useStateFromProps";
import { SearchBrandGroup_search_edges_node } from "@saleor/searches/types/SearchBrandGroup";
import { SearchClusters_search_edges_node } from "@saleor/searches/types/SearchClusters";
import { FetchMoreProps } from "@saleor/types";
import { StoreTypeEnum } from "@saleor/types/globalTypes";
import createSingleAutocompleteSelectHandler from "@saleor/utils/handlers/singleAutocompleteSelectChangeHandler";
import { hasNoError, useValidation } from "@saleor/utils/validators/seller";
import React, { useState } from "react";

import { maybe } from "../../../misc";
import SellerInfo from "../SellerInfo";
export interface SellerCreatePageFormData {
  accountManager: any;
  bankName: string;
  bankAccountName: string;
  bankAccountNo: string;
  cluster: string;
  code: string;
  completeAddress: string;
  customerCode: string;
  financeName: string;
  financeEmail: string;
  financeMobileNo: string;
  legalName: string;
  name: string;
  id: string;
  isLargeTaxpayer: boolean;
  isPayoutEligible: boolean;
  signatoryName: string;
  signatoryEmail: string;
  signatoryDesignation: string;
  signatoryMobileNo: string;
  storeType: string;
  status: string;
  tinNo: string;
  vendorCode: string;
  vertical: string;
  swornDeclarationsFlag: boolean;
}
export interface SellerFormValidation {
  bankName: string;
  bankAccountName: string;
  bankAccountNo: string;
  financeName: string;
  financeEmail: string;
  financeMobileNo: string;
  legalName: string;
  name: string;
  signatoryName: string;
  signatoryEmail: string;
  signatoryDesignation: string;
  signatoryMobileNo: string;
  storeType: string;
  tinNo: string;
  vertical: string;
}
interface SellerCreateProp {
  errors: BrandErrorFragment[];
  onBack: () => void;
  onSubmit: (data: SellerCreatePageFormData) => SubmitPromise;
  fetchMoreBrands?: FetchMoreProps;
  fetchBrands: (query: string) => void;
  saveButtonBarState: ConfirmButtonTransitionState;
  disabled: boolean;
  sellerList: SearchBrandGroup_search_edges_node[];
  fetchClusters: (query: string) => void;
  fetchMoreClusters?: FetchMoreProps;
  clusterList: SearchClusters_search_edges_node[];
  hasShopifyPermission?: boolean;
}

export const SellerCreatePage: React.FC<SellerCreateProp> = ({
  errors,
  onSubmit,
  onBack,
  saveButtonBarState,
  fetchBrands,
  fetchMoreBrands,
  disabled,
  sellerList,
  fetchClusters,
  fetchMoreClusters,
  clusterList,
  hasShopifyPermission
}) => {
  const initialForm: SellerCreatePageFormData = {
    accountManager: null,
    bankAccountName: null,
    bankAccountNo: null,
    bankName: null,
    cluster: null,
    code: null,
    completeAddress: null,
    customerCode: null,
    financeEmail: null,
    financeMobileNo: null,
    financeName: null,
    id: null,
    isLargeTaxpayer: null,
    isPayoutEligible: null,
    legalName: null,
    name: null,
    signatoryDesignation: null,
    signatoryEmail: null,
    signatoryMobileNo: null,
    signatoryName: null,
    status: null,
    storeType: null,
    swornDeclarationsFlag: null,
    tinNo: null,
    vendorCode: null,
    vertical: null
  };

  const [sellerDisplayName, setSellerDisplayName] = useStateFromProps("");
  const [clusterDisplayName, setClusterDisplayName] = useStateFromProps("");

  const sellerChoices = maybe(
    () =>
      sellerList.map(brandGroup => ({
        classification: brandGroup?.classification,
        label: brandGroup?.name,
        value: brandGroup?.name,
        vertical: brandGroup?.vertical
      })),
    []
  );

  const clusterChoices = maybe(
    () =>
      clusterList.map(cluster => ({
        label: cluster?.name,
        value: cluster?.id
      })),
    []
  );
  const initalFormValidation: SellerFormValidation = {
    bankAccountName: null,
    bankAccountNo: null,
    bankName: null,
    financeEmail: null,
    financeMobileNo: null,
    financeName: null,
    legalName: null,
    name: null,
    signatoryDesignation: null,
    signatoryEmail: null,
    signatoryMobileNo: null,
    signatoryName: null,
    storeType: null,
    tinNo: null,
    vertical: null
  };
  const [clientError, setErrorValdiation] = useState(initalFormValidation);

  const hanldeSubmit = event => {
    const validate = useValidation(event, "RVW");
    if (hasNoError(validate)) {
      setErrorValdiation(validate);
      onSubmit(event);
    } else {
      setErrorValdiation(validate);
    }
  };

  const breadcrumbDirectory = [
    {
      name: "Sellers",
      url: "/seller"
    },
    {
      name: "Create Seller"
    }
  ];

  return (
    <>
      <Form initial={initialForm} onSubmit={hanldeSubmit} confirmLeave>
        {({ data, change, submit, hasChanged }) => {
          const handleSelectBrand = createSingleAutocompleteSelectHandler(
            change,
            setSellerDisplayName,
            sellerChoices
          );
          const handleSelectCluster = createSingleAutocompleteSelectHandler(
            change,
            setClusterDisplayName,
            clusterChoices
          );

          if (
            data.storeType !== StoreTypeEnum.FOOD_AND_BEVERAGES &&
            data.cluster !== null
          ) {
            change({
              target: {
                name: "cluster",
                value: null
              }
            });

            setClusterDisplayName("");
          }
          return (
            <Container>
              <PageBreadcrumbNavigation items={breadcrumbDirectory} />
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginTop: "10px"
                }}
              >
                <PageBackNavigation onBack={onBack} />
                <PageHeader title={"Create Seller"}></PageHeader>
              </div>

              <Grid>
                <SellerInfo
                  hasShopifyPermission={hasShopifyPermission}
                  createSeller={true}
                  data={data}
                  disabled={disabled}
                  errors={errors}
                  clientError={clientError}
                  onChange={change}
                  sellerDisplayValue={sellerDisplayName}
                  seller={sellerChoices}
                  fetchBrands={query => fetchBrands(query)}
                  fetchMoreBrands={fetchMoreBrands}
                  onSellerChange={handleSelectBrand}
                  onGenerateDeeplink={() => undefined}
                  onFileSizeError={() => undefined}
                  clusters={clusterChoices}
                  fetchClusters={query => fetchClusters(query)}
                  fetchMoreClusters={fetchMoreClusters}
                  onClusterChange={handleSelectCluster}
                  clusterDisplayValue={clusterDisplayName}
                />
              </Grid>

              <div>
                <SaveButtonBar
                  state={saveButtonBarState}
                  onCancel={onBack}
                  onSave={submit}
                  disabled={disabled || !hasChanged}
                />
              </div>
            </Container>
          );
        }}
      </Form>
    </>
  );
};

export default SellerCreatePage;
